import { UsersIcon } from "@heroicons/react/20/solid";
import { PlacementId } from "@sp-crm/core";
import { useQuery } from "@tanstack/react-query";
import { trpc } from "components/rpc/trpc";
import React, { useCallback } from "react";
import { useFeature } from "store/selectors/hooks";
import { useTenantSettings } from "store/selectors/settings";

interface CollaboratorsHeaderLinkProps {
    clientId: PlacementId;
    onClick: () => void;
}

export const CollaboratorsHeaderLink: React.FC<CollaboratorsHeaderLinkProps> = props => {
    const { clientId, onClick } = props;
    const trpcClient = trpc.useTRPC();
    const { settings } = useTenantSettings();

    const enabled = useFeature("clientCollaborators") && settings.clientCollaborators;

    const collaboratorsQuery = useQuery({
        ...trpcClient.collaborators.listForClient.queryOptions({ placementId: clientId }),
        enabled,
    });

    const handleClick = useCallback(
        (e: React.MouseEvent) => {
            e.preventDefault();
            onClick();
        },
        [onClick],
    );

    const collaboratorCount = collaboratorsQuery.data?.length || 0;

    if (collaboratorsQuery.isLoading || !enabled) {
        return null;
    }

    return (
        <button
            onClick={handleClick}
            className="text-gray-500 hover:text-gray-900 flex items-center gap-1 cursor-pointer transition-colors"
            title="Manage collaborators">
            <UsersIcon className="w-4 h-4" />
            <span>{collaboratorCount}</span>
        </button>
    );
};
